import { action, makeObservable, observable } from 'mobx';

import { gameLiveConnection, soundService } from '../services';
import { parseQuery } from '../helpers/parseQuery';
import { DefaultQueryParams } from '../constants/defaultQueryParams';
import { winBarStore } from './winBarStore';
import { betBarStore } from './betBarStore';
import { applicationStore } from './applicationStore';
import { gameMainDrawer } from '../game/drawers/gameMainDrawer';
import { userInfoStore } from './userInfoStore';
import { SoundTypes } from '../services/baseSoundService/soundService';
import { gameStore } from './gameStore';

class SpinBarStore {
  gameReelSpeedMode = {
    standard: true,
    fast: false,
    faster: false,
  };

  freeBetId = null;

  tournamentId = null;

  jackpotExpiredTime = 0;

  freeBetList = [];

  nextFreeBet = null;

  activeFreeBetIndex = 0;

  gameReelSpeedType = 'standard';

  selectedAutoBetCount = null;

  isAutoBetStart = false;

  isAutoBetPopupOpen = false;

  isAutoBetStopButtonVisible = false;

  isSpinStart = false;

  isDoubleClick = false;

  scatterStarCount = 0;

  scatterDollarCount = 0;

  jackpotIconCount = 0;

  isStoppedAllReels = false;

  constructor() {
    makeObservable(this, {
      freeBetId: observable,
      tournamentId: observable,
      isSpinStart: observable,
      jackpotIconCount: observable,
      isDoubleClick: observable,
      scatterStarCount: observable,
      isStoppedAllReels: observable,
      scatterDollarCount: observable,
      isAutoBetStart: observable,
      freeBetList: observable,
      nextFreeBet: observable,
      activeFreeBetIndex: observable,
      gameReelSpeedType: observable,
      jackpotExpiredTime: observable,
      isAutoBetPopupOpen: observable,
      gameReelSpeedMode: observable,
      selectedAutoBetCount: observable,
      isAutoBetStopButtonVisible: observable,
      resetStore: action.bound,
      setIsAutoBetStart: action.bound,
      setGameReelSpeedMode: action.bound,
      setIsSpinStart: action.bound,
      setIsDoubleClick: action.bound,
      autoBetPopupToggle: action.bound,
      updateGameReelSpeedMode: action.bound,
      setGameReelSpeedType: action.bound,
      setFreeBetList: action.bound,
      setTournamentId: action.bound,
      setFreeBetId: action.bound,
      setScatterStarCount: action.bound,
      resetScattersCount: action.bound,
      setJackpotIconCount: action.bound,
      setScatterDollarCount: action.bound,
      setNextFreeBet: action.bound,
      setSelectedAutoBetCount: action.bound,
      setIsAutoBetStopButtonVisible: action.bound,
      setIsStopAllReels: action.bound,
    });
  }

  setScatterStarCount(count) {
    this.scatterStarCount += count;
  }

  setScatterDollarCount(count) {
    this.scatterDollarCount += count;
  }

  setJackpotIconCount(count) {
    this.jackpotIconCount += count;
  }

  resetScattersCount() {
    this.scatterStarCount = 0;
    this.scatterDollarCount = 0;
    this.jackpotIconCount = 0;
  }

  setNextFreeBet(nextFreeBet) {
    this.nextFreeBet = nextFreeBet;
  }

  setActiveFreeBetIndex(index) {
    this.activeFreeBetIndex = index;
  }

  setFreeBetList(freeBetList) {
    this.freeBetList = freeBetList;
  }

  setFreeBetId(id) {
    this.freeBetId = id;
  }

  setTournamentId(id) {
    this.tournamentId = id;
  }

  setGameReelSpeedType(type) {
    this.gameReelSpeedType = type;
  }

  setGameReelSpeedMode(key, value) {
    this.gameReelSpeedMode = {
      standard: false,
      fast: false,
      faster: false,
      [key]: value,
    };
  }

  updateGameReelSpeedMode() {
    const key = this.gameReelSpeedMode.standard
      ? 'fast'
      : this.gameReelSpeedMode.fast
      ? 'faster'
      : 'standard';
    this.setGameReelSpeedType(key);
    this.setGameReelSpeedMode(key, true);
  }

  setIsAutoBetStart(bool) {
    this.isAutoBetStart = bool;
  }

  setIsDoubleClick(bool) {
    this.isDoubleClick = bool;
  }

  setIsSpinStart(bool) {
    this.isSpinStart = bool;
    if (!bool) {
      this.setIsDoubleClick(false);
    }
  }

  setSelectedAutoBetCount(count) {
    this.selectedAutoBetCount = count;
  }

  setIsAutoBetStopButtonVisible(boolValue) {
    this.isAutoBetStopButtonVisible = boolValue;
  }

  autoBetPopupToggle(bollValue) {
    if (bollValue !== undefined) {
      this.isAutoBetPopupOpen = bollValue;
    } else {
      this.isAutoBetPopupOpen = !this.isAutoBetPopupOpen;
    }
  }

  setIsStopAllReels(boolValue) {
    this.isStoppedAllReels = boolValue;
  }

  doSpin() {
    const { [DefaultQueryParams.PartnerId]: partnerId, [DefaultQueryParams.GameId]: gameId } =
      parseQuery(window.location.search);
    const spinModel = {
      amount: betBarStore.selectedAmount,
      spinData: true,
      gameId: gameId,
      freeBetId: this.freeBetId,
      tournamentId: this.tournamentId,
      partnerId: partnerId,
    };
    winBarStore.setIsScatterWin(false);
    winBarStore.setWins([]);
    winBarStore.setWinMatrix([]);
    winBarStore.setIsLastSpinWin(Boolean(winBarStore.winAmount));
    winBarStore.setWinAmount(0);
    winBarStore.setExpandingWildData([]);
    gameMainDrawer.expandWildBar.wild.visible = false;
    soundService.stopAll();
    soundService.play(SoundTypes.SpinButton);
    if (applicationStore.isDemo && betBarStore.selectedAmount > userInfoStore.balance) {
      gameMainDrawer.popupBar.togglePopupVisibility(true);
      gameMainDrawer.popupBar.setInsufficientAmount();
      gameStore.setGameResultMatrix(gameStore.noWinMatrix);
      gameMainDrawer.spinBar.hideAutoBetPopup();
      return;
    }
    applicationStore.setOperatorError(null);
    applicationStore.isDemo
      ? gameLiveConnection.demoSpin(spinModel)
      : gameLiveConnection.spin(spinModel);
  }

  resetStore() {
    this.freeBetId = null;

    this.tournamentId = null;

    this.jackpotExpiredTime = 0;

    this.isDoubleClick = false;

    this.scatterStarCount = 0;

    this.scatterDollarCount = 0;

    this.jackpotIconCount = 0;
  }
}

export const spinBarStore = new SpinBarStore();
